export default {
  //master distributor
  "View Specific Master Distributor Details": ["Listing Master Distributor"],
  "Activate / Deactivate Master Distributor": ["Listing Master Distributor"],
  "Flagging Master Distributor Transactions": [
    "Listing Master Distributor",
    "View Specific Master Distributor Details",
  ],
  "Edit Master Distributor": ["Listing Master Distributor"],

  //sub distributor
  "View Specific Sub Distributor Details": ["Listing Sub Distributor"],
  "Activate / Deactivate Sub Distributor": ["Listing Sub Distributor"],
  "Flagging Sub Distributor Transactions": [
    "Listing Sub Distributor",
    "View Specific Sub Distributor Details",
  ],
  "Edit Sub Distributor": ["Listing Sub Distributor"],

  //Distributor
  "View Specific Distributor Details": ["Listing Distributor"],
  "Activate / Deactivate Distributor": ["Listing Distributor"],
  "Flagging Distributor Transactions": [
    "Listing Distributor",
    "View Specific Distributor Details",
  ],
  "Edit Distributor": ["Listing Distributor"],
  "Distributor Transactions": [
    "Listing Distributor",
    "View Specific Distributor Details",
  ],

  //Agent
  "View Specific Agent Details": ["Listing Agent"],
  "Activate / Deactivate Agent": ["Listing Agent"],
  "Flagging Agent Transactions": [
    "Listing Agent",
    "View Specific Agent Details",
  ],
  "Edit Agent": ["Listing Agent"],
  "Agent Transactions": ["Listing Agent", "View Specific Agent Details"],

  //Customers
  "View Specific Customer Details": ["Listing Customer"],
  "Activate / Deactivate Customer": ["Listing Customer"],
  "Flagging Customer Transactions": [
    "Listing Customer",
    "View Specific Customer Details",
  ],
  "Edit Customer": ["Listing Customer"],
  "Customer Transactions": [
    "Listing Customer",
    "View Specific Customer Details",
  ],

  // Company Management
  "View Specific Company Details": ["Listing Company"],
  "Edit Company": ["Listing Company"],

  //MNO management
  "Edit MNO": ["Listing MNO"],
  "Add Purchase Amount": ["Listing MNO", "View Specific MNO Details"],
  "Add Service Fee": ["Listing MNO", "View Specific MNO Details"],
  "View Specific MNO Details": ["Listing MNO"],
};

export const dependantRemoverObject = {
  "Listing Master Distributor": [
    "View Specific Master Distributor Details",
    "Flagging Master Distributor Transactions",
    "Edit Master Distributor",
    "Activate / Deactivate Master Distributor",
  ],
  "View Specific Master Distributor Details": [
    "Flagging Master Distributor Transactions",
  ],
  "Listing Sub Distributor": [
    "View Specific Sub Distributor Details",
    "Flagging Sub Distributor Transactions",
    "Edit Sub Distributor",
    "Activate / Deactivate Sub Distributor",
  ],
  "View Specific Sub Distributor Details": [
    "Flagging Sub Distributor Transactions",
  ],
  "Listing Distributor": [
    "View Specific Distributor Details",
    "Flagging Distributor Transactions",
    "Edit Distributor",
    "Activate / Deactivate Distributor",
    "Distributor Transactions",
  ],
  "View Specific Distributor Details": [
    "Flagging Distributor Transactions",
    "Distributor Transactions",
  ],
  "Listing Agent": [
    "View Specific Agent Details",
    "Flagging Agent Transactions",
    "Edit Agent",
    "Activate / Deactivate Agent",
    "Agent Transactions",
  ],
  "View Specific Agent Details": [
    "Flagging Agent Transactions",
    "Agent Transactions",
  ],
  "Listing Customer": [
    "View Specific Customer Details",
    "Flagging Customer Transactions",
    "Edit Customer",
    "Activate / Deactivate Customer",
    "Customer Transactions",
  ],
  "View Specific Customer Details": [
    "Flagging Customer Transactions",
    "Customer Transactions",
  ],
  "Listing Company": [
    "View Specific Company Details",
    "Edit Company",
  ],
  "Listing MNO": [
    "Edit MNO",
    "Add Purchase Amount",
    "Add Service Fee",
    "View Specific MNO Details",
  ],
  "View Specific MNO Details": ["Add Purchase Amount", "Add Service Fee"],
};